import InputField from "components/fields/InputField";
import Default from "layouts/auth/types/Default";
import React from "react";

function SetupNewPasswordDefault() {
  return (
    <Default
      back="/auth/signin"
      maincard={
        <div className="w-full max-w-full flex-col items-center">
          <h2 className="mb-2 text-4xl font-bold text-navy-700 dark:text-white">
            Set up new password
          </h2>
          <p className="mt-[10px] ml-1 mb-8 text-base text-gray-600">
            Welcome back! Set up your new password.
          </p>
          {/* Password */}
          <InputField
            variant="password"
            label="New password"
            placeholder="Password"
            id="email"
            type="text"
            extra="mb-6"
          />

          {/* Confirm Password */}
          <InputField
            variant="confirm_password"
            label="Confirm new password"
            placeholder="Password"
            id="email"
            type="text"
            extra="mb-8"
          />
          {/* button */}
          <button className="mt-4 w-full rounded-xl bg-brand-500 py-3 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-800 dark:text-white dark:hover:bg-brand-700 dark:active:bg-brand-600">
            Confirm
          </button>
        </div>
      }
    />
  );
}

export default SetupNewPasswordDefault;
